const state = {
    inCheckin: false,
    checkinSettings: null,
    basicSettings: {
        url: {
            it: 'https://business.getpica.com/it/?utm_source=getpica.com&utm_medium=referral&utm_campaign=popup',
            en: 'https://business.getpica.com/?utm_source=getpica.com&utm_medium=referral&utm_campaign=popup'
        },
        enabled: false,
    }
}

export const getters = {
    settings: state => {
        if (state.inCheckin) return state.checkinSettings
        return state.basicSettings
    }
}


export const mutations = {
    setInCheckin(state, inCheckin) {
        state.inCheckin = inCheckin
    },
    setCheckinSettings(state, settings) {
        state.checkinSettings = settings
    },
}

export const actions = {
    exitCheckin({commit}) {
        commit('setInCheckin', false)
        commit('setCheckinSettings', null)
    },
    setCheckinSettings({commit}, settings) {
        commit('setCheckinSettings', settings)
        commit('setInCheckin', true)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
